import { requestPost } from '@/common/request';

//数据上报接口
export default function skuPoolServiceQueryGeneralDataScopeByErp(query = {}) {
  return requestPost('/generic/skuPoolService/queryGeneralDataScopeByErp', query);
}
